<h2 class="mt-0">Bestenliste</h2>
<div class="row">
  <div class="col-md-3 mb-2">
    <div class="card clickable" routerLink="overall" routerLinkActive="active-card">
      <div class="card-body">
        <h5 class="card-title">Gesamt</h5>
        <p class="card-text">Ultimative Wertung: Alle Punkte, alle Events!</p>
      </div>
    </div>
  </div>
  <div class="col-md-3 mb-2">
    <div class="card clickable" routerLink="WWE" routerLinkActive="active-card">
      <div class="card-body">
        <h5 class="card-title">WWE</h5>
        <p class="card-text">Die Rangliste rund um alle Main-PLEs des Marktführers.</p>
      </div>
    </div>
  </div>
  <div class="col-md-3 mb-2">
    <div class="card clickable" routerLink="NXT" routerLinkActive="active-card">
      <div class="card-body">
        <h5 class="card-title">NXT</h5>
        <p class="card-text">Das Ranking für echte Nachwuchs-Experten!</p>
      </div>
    </div>
  </div>
  <div class="col-md-3 mb-2">
    <div class="card clickable" routerLink="AEW" routerLinkActive="active-card">
      <div class="card-body">
        <h5 class="card-title">AEW</h5>
        <p class="card-text">Hast du Tony Khans Booking verstanden? </p>
      </div>
    </div>
  </div>
</div>


<router-outlet></router-outlet>

